import { render } from 'react-dom';
import Form100GraphSpain from './form100GraphSpain';

const rootElement = document.querySelector('#root');
if (rootElement) {
  render(
    <Form100GraphSpain/>,
    rootElement);
}
